import { render, staticRenderFns } from "./authorizationDialog.vue?vue&type=template&id=0e8d3358&scoped=true&"
import script from "./authorizationDialog.vue?vue&type=script&lang=js&"
export * from "./authorizationDialog.vue?vue&type=script&lang=js&"
import style0 from "./authorizationDialog.vue?vue&type=style&index=0&id=0e8d3358&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8d3358",
  null
  
)

export default component.exports